/**
 * Created by Owner on 2016/8/9.
 */
import {Component, OnChanges} from '@angular/core';
import {NavController, AlertController, ViewController, NavParams, Keyboard} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";
import {AppDialog} from "../../component/appDialog";
import {UserBetListPage} from "../userBetList/userBetList";
import {TraceListPage} from "../traceList/traceList";

@Component({
    templateUrl: 'gameRecordSearch.html',
    selector: 'game-record-search-page',
})
export class GameRecordSearchPage implements OnChanges{
    private selectAction: string = "action1";
    status: number = -1;
    betid: string = "";
    starttime: string;
    endtime: string;
    lotteryid: number = -1;
    statuslist: any = [];
    lotterylist: any = [];

    betid1: string = "";
    starttime1: string;
    endtime1: string;

    constructor(private keyboard: Keyboard, private navParams: NavParams, private nav: NavController, private alertCtrl: AlertController,
                private userService: UserService, public viewCtrl: ViewController) {
        this.initData();
    }

    initData() {
        this.userService.gameRecordInit(undefined, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.statuslist = data["statuslist"];
                this.lotterylist = data["lotterylist"];
                this.starttime = data["starttime"].replace(" ", "T");
                this.endtime = data["endtime"].replace(" ", "T");

                this.starttime1 = data["starttime"].replace(" ", "T");
                this.endtime1 = data["endtime"].replace(" ", "T");
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    searchFn() {
        let requestData: any = {
            status: this.status,
            betid: this.betid,
            starttime: this.starttime.replace("T", ' ').substr(0, 19),
            endtime: this.endtime.replace("T", ' ').substr(0, 19),
            lotteryid: this.lotteryid
        };
        this.userService.gameRecordSearch(requestData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.nav.push(UserBetListPage, {
                    requestData: requestData,
                    data: data
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    search1Fn() {
        let requestData: any = {
            betid: this.betid,
            starttime: this.starttime1.replace("T", ' ').substr(0, 19),
            endtime: this.endtime1.replace("T", ' ').substr(0, 19),
        };
        this.userService.traceSearch(requestData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.nav.push(TraceListPage, {
                    requestData: requestData,
                    data: data
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    ionViewWillLeave() {
        this.keyboard.close();
    }

    ngOnChanges() {
        console.log(this.starttime);
    }
}



// WEBPACK FOOTER //
// ./src/pages/gameRecordSearch/gameRecordSearch.ts